const trekId = 'e[a-z0-9A-Z]{11}';
const userId = 'a[a-z0-9A-Z]{11}';
const lodgeId = 'b[a-z0-9A-Z]{11}';
const placeId = 'd[a-z0-9A-Z]{11}';

export { trekId, userId, lodgeId, placeId };



// WEBPACK FOOTER //
// ./src/constants/idRegex.js